module.exports = __webpack_public_path__ + "static/media/19_FVCON_(opcional).012655b2.png";